import React from 'react'
import {CalendarPopover, DateInput} from '@sabre/spark-react'


export default (locals) => {

    const {
        attrs: {
            className,
            format,
            isSelect,
            isTypeahead,
            max,
            min,
            onBlur,
            onFocus,
            popoverOptions,
            showDateAsText,
            textFormat
        },
        error,
        hasError,
        label,
        onChange
    } = locals

    let errorMessage = ''

    if (hasError && error && error.props && error.props.children) {
        errorMessage = error.props.children
    }

    const props = {
        className: className ? className : '',
        dateInputOptions: {
            format,
            isSelect,
            isTypeahead,
            max,
            min,
            onBlur,
            onFocus,
            onChange: value => {
                onChange(new Date(value))
            },
            showDateAsText,
            textFormat
        },
        errorMessage,
        inputProps: {
            defaultValue: defaultDateFromValue(),
            max,
            min
        },
        label
    }

    Object.keys(props).forEach(key1 => {
        if (props[key1] === undefined) delete props[key1]
        Object.keys(props[key1]).forEach(key2 => {
            if (props[key1][key2] === undefined) delete props[key1][key2]
        })
    })

    function defaultDateFromValue() {
        let defaultDate = null
        if (!locals.value[0])
            return defaultDate
        let month = `0${parseInt(locals.value[1], 10) + 1}`.slice(-2)
        let day = `0${locals.value[2]}`.slice(-2)
        return `${locals.value[0]}-${month}-${day}`
    }

    return (
        <CalendarPopover {...popoverOptions}>
            <DateInput {...props} />
        </CalendarPopover>
    )
}


// WEBPACK FOOTER //
// ./src/shared/components/tcomb/sparkDateLayout.js